import React from 'react'
import { Can } from 'permissions'
import { InsufficientPermissions } from 'screens/errors'

const PermissionAuthenticator = ({ action, on, children }) => {
  if (action && on) {
    return (
      <Can I={action} a={on} passThrough>
        {(allowed) => (allowed ? children : <InsufficientPermissions />)}
      </Can>
    )
  }
  return children
}

export { PermissionAuthenticator }
